import React from 'react';

import { useHomeData } from '../components/LoadHomeData/HomeDataProvider';
import { NFC } from '../components/NFC/NFC';
import { NoAccessToView } from '../components/NoAccessToView/NoAccessToView';
import { useTranslations } from '../components/Translations/TranslationsProvider';

export const NFCPage = () => {
    const { translations } = useTranslations();
    const { homepageData } = useHomeData();
    const isGuard = homepageData?.authorizations?.mayUseGuardsMobileFx ?? false;

    return (
        <>
            {!isGuard && <NoAccessToView translations={translations} />}
            {isGuard && <NFC translations={translations} />}
        </>
    );
};
